import type { Language } from '@/bindings/Language'
import type { LocalizedText } from '@/bindings/LocalizedText'
import { LANGUAGES } from '@/lib/i18n/languages'

/** Every registry language, '' when unfilled; hidden languages keep their text (E6 pattern). */
export type NameDraft = Record<Language, string>

export function namesFrom(text: LocalizedText | undefined): NameDraft {
  const draft = {} as NameDraft
  for (const language of LANGUAGES) draft[language] = text?.[language] ?? ''
  return draft
}

/** Blanks are dropped: presence means filled (B3). */
export function toLocalizedText(draft: NameDraft): LocalizedText {
  const text: LocalizedText = {}
  for (const language of LANGUAGES) {
    const value = draft[language].trim()
    if (value) text[language] = value
  }
  return text
}
